import React from 'react';

const SatToolTip = props => {
  const {
    show,
    setShow,
    toolTips,
    iconStyleClass = 'ico-alim',
    customStyleClass = '',
    position = 'bottom',
    divStyle = {},
  } = props;

  const tooltipWrapClass = () => {
    let className = `tooltip-box ${position}`;

    if (customStyleClass !== '') className += ` ${customStyleClass}`;

    return className;
  };

  return (
    <div className="tooltip-wrap" style={divStyle}>
      <span
        className={`ico ${iconStyleClass} ${show && 'active'}`}
        onClick={() => setShow(true)}
      />
      {show && (
        <>
          <div
            className={tooltipWrapClass()}
            onClick={e => {
              // 툴팁 안의 영역 클릭시 닫지말기
              e.stopPropagation();
            }}
          >
            {toolTips.map((tip, i) => {
              return (
                <React.Fragment key={`${tip.title}-${i}`}>
                  <strong>{tip.title}</strong>
                  {typeof tip.message === 'function' ? tip.message() : ''}
                </React.Fragment>
              );
            })}
          </div>
          <div
            className="dim-transparent"
            style={{ display: 'block' }}
            onClick={() => {
              // 톨팁 밖의 영역 클릭시 닫기
              setShow(false);
            }}
          ></div>
        </>
      )}
    </div>
  );
};

export default SatToolTip;
